export default __webpack_public_path__ + "static/media/vehicles-list.76b86a06.png";